import template from './swag-cms-extensions-page-scroll-behavior-config.html.twig';
import './swag-cms-extensions-page-scroll-behavior-config.scss';

export default {
    template,

    inject: [
        'repositoryFactory',
        'acl',
    ],

    props: {
        page: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            defaults: {
                active: false,
                duration: 1000,
                easing: 'inOut',
                easingDegree: 3,
                bouncy: false,
                nativeScrolling: true,
            },
            easings: ['linear', 'in', 'out', 'inOut'],
        };
    },

    computed: {
        scrollNavigationPageSettingsRepository() {
            return this.repositoryFactory.create('swag_cms_extensions_scroll_navigation_page_settings');
        },

        scrollNavigationPageSettingsDefined() {
            return this.page.extensions.swagCmsExtensionsScrollNavigationPageSettings !== undefined;
        },

        scrollNavigationPageSettings() {
            return this.page.extensions.swagCmsExtensionsScrollNavigationPageSettings;
        },

        pageHasNavigationPoints() {
            return this.page.sections.some((section) => {
                return section.extensions.swagCmsExtensionsScrollNavigation?.active;
            });
        },

        smoothScrollingActive() {
            return this.pageHasNavigationPoints && this.scrollNavigationPageSettings.active;
        },

        easingTypes() {
            return this.easings.map((type) => {
                return {
                    value: type,
                    label: this.$tc(`swag-cms-extensions.sw-cms.detail.scrollNavigation.pageSettings.easing.${type}`),
                };
            });
        },

        easingDegreeDisabled() {
            return !this.smoothScrollingActive ||
                this.scrollNavigationPageSettings.easing === 'linear' ||
                this.scrollNavigationPageSettings.bouncy === true;
        },
    },

    watch: {
        page: {
            handler() {
                if (typeof this.page.extensions?.swagCmsExtensionsScrollNavigationPageSettings === 'object') {
                    return;
                }
                this.createDefaultScrollNavigationPageSettings();
            },
            immediate: true,
        },
    },

    /**
     * @deprecated tag:v6.0.0 - Function and the createdComponent call will be removed without replacement
     */
    created() {
        this.createdComponent();
    },

    methods: {
        /**
         * @deprecated tag:v6.0.0 - Removed without replacement
         */
        createdComponent() {
            this.setDefaults();
        },

        /**
         * @deprecated tag:v6.0.0 - Removed without replacement
         */
        setDefaults() {},

        createDefaultScrollNavigationPageSettings() {
            const defaultExtension = this.scrollNavigationPageSettingsRepository.create(Shopware.Context.api);

            Object.entries(this.defaults).forEach(([property, defaultValue]) => {
                defaultExtension[property] = defaultValue;
            });

            this.page.extensions.swagCmsExtensionsScrollNavigationPageSettings = defaultExtension;
        },

        /**
         * @deprecated tag:v6.0.0 - Removed without replacement
         */
        pageSettingsActiveChanged() {},
    },
}
